<script>
  import { onMount } from "svelte";
  import { localeOrderBy } from "../../mjnUtils";

  let { http, toastr, onSave, onCancel } = $props();

  let imports = $state([]);
  let dataImp = $state(null);
  let submitted = $state(false);

  onMount(() => {
    http.get("/api/transakcja-import.php").then(
      (response) => {
        if (response.data.status == 200) {
          imports = response.data.records;
        } else {
          toastr.error("Błąd: " + response.data.message);
        }
      },
      () => {
        toastr.error("Błąd połączenia");
      },
    );
  });

  let sortedImports = $derived(localeOrderBy(imports, "data_imp", true));

  function isValid() {
    return dataImp !== null && dataImp !== undefined;
  }

  function ok() {
    submitted = true;
    if (!isValid()) return;
    onSave(dataImp);
  }
</script>

<div class="modal-header">
  <h4 class="modal-title" id="myModalLabel">Skasuj import transakcji</h4>
</div>
<div class="modal-body">
  <div class="panel panel-default">
      <div class="panel-body">
            <form name="theForm" class="form form-inline" onsubmit={(e) => { e.preventDefault(); ok(); }} role="form">
            <table class="table table-condensed table-hover table-striped">
			<tbody>
			  <tr>
				<td>
				Wybierz&nbsp;import:
				</td>
                <td>
                    <select class="form-control input-sm" name="import" bind:value={dataImp} required>
    				  {#each sortedImports as imp}<option value={imp.data_imp}>{imp.bank} {imp.data_imp} ({imp.liczba_tr} transakcji, {imp.od} - {imp.do})</option>{/each}
    				</select>
				</td>
			  </tr>
              <tr>
               <td>
               </td>
                <td>
                    <small class="text-muted">Możesz jednorazowo wybrać tylko jeden import do usunięcia. Jeśli chcesz usunąć więcej, otwórz to okienko jeszcze raz.</small>
               </td>
             </tr>
			</tbody>
			</table>
            </form>
      </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-danger" onclick={ok}>Skasuj</button>
  <button class="btn btn-default" onclick={onCancel}>Anuluj</button>
</div>
